import React, { FC, useMemo } from 'react';
import { DragIndicator as DragIndicatorIcon } from '@mui/icons-material';
import { ChartCardProps } from './ChartCard.props';
import { CardBody, CardTopContent, DragIndicator, StyledCard } from './ChartCard.styles';

export const ChartCard: FC<ChartCardProps> = ({ children, className, locked = true, testId }) => {
  const { topContent, chartContent } = useMemo(() => {
    const childrenArray = React.Children.toArray(children);

    // If there's only one child, it's the chart
    if (childrenArray.length <= 1) {
      return {
        topContent: null,
        chartContent: children,
      };
    }

    // If there are multiple children, all but the last are top content, last is the chart
    return {
      topContent: childrenArray.slice(0, -1),
      chartContent: childrenArray[childrenArray.length - 1],
    };
  }, [children]);

  return (
    <StyledCard className={className} data-testid={testId} elevation={2}>
      {!locked && (
        <DragIndicator>
          <DragIndicatorIcon fontSize="small" />
        </DragIndicator>
      )}
      {topContent && <CardTopContent>{topContent}</CardTopContent>}
      <CardBody>{chartContent}</CardBody>
    </StyledCard>
  );
};

export default ChartCard;
